const PLACED_ORDER_STORAGE_KEY = "vf_klaviyo_placed_orders";
const VIEW_DEDUP_STORAGE_KEY = "vf_klaviyo_view_dedup";
const VIEW_DEDUP_TTL_MS = 30 * 1000;

export const wasOrderReported = (orderId: string): boolean => {
  if (typeof window === "undefined" || !window.sessionStorage) return false;
  try {
    const raw = window.sessionStorage.getItem(PLACED_ORDER_STORAGE_KEY) || "";
    if (!raw) return false;
    return raw.split(",").indexOf(orderId) !== -1;
  } catch (e) {
    return false;
  }
};

export const markOrderReported = (orderId: string) => {
  if (typeof window === "undefined" || !window.sessionStorage) return;
  try {
    const raw = window.sessionStorage.getItem(PLACED_ORDER_STORAGE_KEY) || "";
    const ids = raw ? raw.split(",") : [];
    if (ids.indexOf(orderId) === -1) {
      ids.push(orderId);
      const trimmed = ids.slice(-25).join(",");
      window.sessionStorage.setItem(PLACED_ORDER_STORAGE_KEY, trimmed);
    }
  } catch (e) {
    // best-effort only
  }
};

const readViewDedup = (): Record<string, number> => {
  if (typeof window === "undefined" || !window.sessionStorage) return {};
  try {
    const raw = window.sessionStorage.getItem(VIEW_DEDUP_STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch (e) {
    return {};
  }
};

const writeViewDedup = (map: Record<string, number>) => {
  if (typeof window === "undefined" || !window.sessionStorage) return;
  try {
    window.sessionStorage.setItem(VIEW_DEDUP_STORAGE_KEY, JSON.stringify(map));
  } catch (e) {
    // best-effort only
  }
};

/**
 * Returns true if `event:id` was reported within VIEW_DEDUP_TTL_MS, otherwise
 * marks it now and returns false. Cheap O(n) sweep keeps the bag small.
 */
export const shouldSkipView = (event: string, id: string | number): boolean => {
  const key = `${event}:${id}`;
  const now = Date.now();
  const map = readViewDedup();
  for (const k of Object.keys(map)) {
    if (now - map[k] > VIEW_DEDUP_TTL_MS) delete map[k];
  }
  if (map[key] && now - map[key] <= VIEW_DEDUP_TTL_MS) {
    writeViewDedup(map);
    return true;
  }
  map[key] = now;
  writeViewDedup(map);
  return false;
};
